import style from './index.module.scss';
import { useEditor, ChildrenBlock, useChildrenBlocks } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

const Buttons = ({ setShowMenu }) => {
    const { isEditing } = useEditor();
    const { children } = useChildrenBlocks();

    return (
        <div className={style.buttons}>
            {isEditing ? (
                <ChildrenBlock
                    gutenbergEditorConfig={{
                        orientation: 'vertical',
                        allowedBlocks: ['smartfire/button'],
                    }}
                    className={style.links}
                />
            ) : (
                <div className={style.links}>
                    {children.map((c, i) => {
                        const link = c.props.node.block.props.link;
                        return (
                            <div key={i} onClick={link === '#newsletter' ? () => setShowMenu(false) : null}>
                                {c}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

function Top({ languages, setShowMenu }) {
    const { isEditing } = useEditor();
    const Wrapper = isEditing ? 'div' : 'a';
    const { t } = useTranslation();

    return (
        <div className={style.top}>
            <Wrapper href="/">
                {isEditing && <p>{t('Choix logo desktop')} :</p>}
                <EditableImg smartProp={'simple_logo'} className={clsx(style.simpleLogo, isEditing && style.editing)} />
                {isEditing && <p>{t('Choix logo menu burger (blanc)')} :</p>}
                <EditableImg
                    smartProp={'simple_logo_white'}
                    className={clsx(style.simpleLogoWhite, isEditing && style.editing)}
                />
            </Wrapper>
            <div className={style.buttons}>
                <Buttons setShowMenu={setShowMenu} />
                {languages && (
                    <div className={style.languages}>
                        {Object.keys(languages).length > 1 &&
                            Object.values(languages).map((language, index) => (
                                <div key={index} className={style.col}>
                                    <a href={language.url} className={language.active ? style.selected : ''}>
                                        <img src={language.country_flag_url} alt={language.native_name} />
                                    </a>
                                </div>
                            ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Top;
